const getCheckboxGlobalProps = props => Object.keys(props).reduce((prev, key) => {
  if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role' || key === 'elRef') {
    prev[key] = props[key];
  }
  return prev;
}, {});

export { getCheckboxGlobalProps };
